import { useEffect } from 'react'
import { createInstance, Identify } from '@amplitude/analytics-browser'
import { UserInfo } from './useAuthUserInfo'
import { ENV_PROD, ENV_STAGING } from '../constants/datadog'
import { AnalyticsEventProperties } from '../analytics/analytics-types'

const AMPLITUDE_ENABLED_ENVIRONMENTS = [ENV_PROD, ENV_STAGING]
const amplitudeIsEnabled = AMPLITUDE_ENABLED_ENVIRONMENTS.includes(import.meta.env.REACT_APP_ENV)
const AMPLITUDE_API_KEY = import.meta.env.REACT_APP_AMPLITUDE_API_KEY

let amplitudeInstance = null

const initializeAmplitude = (uid: string) => {
  if (amplitudeIsEnabled && !amplitudeInstance) {
    amplitudeInstance = createInstance()
    amplitudeInstance.init(AMPLITUDE_API_KEY, uid, { autocapture: true, serverZone: 'EU' })
    amplitudeInstance.setUserId(uid)
  }
}

export const useAmplitude = (user: UserInfo) => {
  useEffect(() => {
    if (!user) return
    initializeAmplitude(user.uid)
    if (amplitudeInstance) {
      const identifyEvent = new Identify()
      identifyEvent.set('sitename', user.sitename ?? 'not-available')
      identifyEvent.set('job_name', user.jobname ?? 'not-available')
      amplitudeInstance.identify(identifyEvent)
    }
  }, [user])
}

export const logAmplitudeEvent = (eventName: string, eventProperties?: AnalyticsEventProperties) =>
  amplitudeInstance?.logEvent(eventName, eventProperties)
